import Cookies from 'js-cookie'

const TokenKey = 'X-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setCookie(key,token) {
  return Cookies.set(key, token)
}
export function getCookie(key) {
  return Cookies.get(key)
}

export function getLang() {
  let lang = getCookie('web_language_wm')
  let ret = 'zh-cn'
  if(lang === 'zh'){
    ret = 'zh-cn'
  }else if(lang === 'en'){
    ret = 'en-us'
  }else if(lang === 'tc'){
    ret = 'zh-tw'
  }
  return ret
}

export function getYdylFileLang() {
  let lang = getCookie('web_language_wm')
  let ret = 'zh-CN'
  if(lang === 'zh'){
    ret = 'zh-CN'
  }else if(lang === 'en'){
    ret = 'en'
  }else if(lang === 'tc'){
    ret = 'zh-TW'
  }
  return ret
}



// WEBPACK FOOTER //
// ./src/base/cookie.js